import React, { useState } from "react";
import { TableUi } from "../../components/table.ui";
import { useMutation, useQuery } from "react-query";
import GymSpaService from "../../services/gym_spa.service"
import { Modal } from "flowbite-react";
import { LoadingUi } from "../../components/components";
import { useAuth } from "../../middleware/auth.middleware";
import { toast } from "react-toastify";
import dayjs from "dayjs"

export const EnCoursGYMSPA = () => {
  const { role } = useAuth()
  const _gymspa = useQuery(['gymspa', role]);
  


  const [state, setState] = useState({
    showModal: false,
    gymspaId: null,
  })

  const initState = () => setState({
    ...state,
    showModal: false,
    gymspaId: null,
  })

  const _terminer = useMutation(GymSpaService.terminer, {
    onSuccess: resp => {
      setState({ ...state, showModal: false, gymspaId: null })
      _gymspa.refetch()
      toast.success('Terminée avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
  })
  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src='/assets/employe.png'
          />
        </div>
      ),
    },
    {
      Header: "Employé",
      accessor: "userId",
      Cell: ({ cell }) => (
        <div className="">
          {
            cell.row.values.userId.prenom.charAt(0).toUpperCase() + cell.row.values.userId.prenom.slice(1) + ' ' + cell.row.values.userId.nom
          }
        </div>
      ),
    },
    {
      Header: "Forfait",
      accessor: "forfait",
    },
    {
      Header: "Type",
      accessor: "typeGS",
    },
    {
      Header: "Prix",
      accessor: "prix",
      Cell: (row) => {
        return <span>{row.row.original.prix} GNF</span>;
      },
    },
    
    {
      Header: "Date de début",
      accessor: "dateDebut",
      Cell: (row) => {
        const date = dayjs(row.row.original.dateDebut).format(
          "DD/MM/YYYY HH:mm"
        );
        return <span>{date}</span>;
      },
    },
    {
      Header: "Date de fin",
      accessor: "dateFin",
      Cell: (row) => {
        const date = dayjs(row.row.original.dateFin).format(
          "DD/MM/YYYY HH:mm"
        );
        return <span>{date}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Mode de paiement",
      accessor: "methodePaiement",
    },
    {
      Header: "Action",
      Cell: ({ cell }) => (
        <div className="flex gap-3 justify-center">
          <span className="bg-green-200 cursor-pointer px-2 rounded-lg text-green-500 font-semibold p-1"
            onClick={() => {
              _terminer.reset()
              setState({
                ...state,
                showModal: !state.showModal,
                gymspaId: cell.row.values,
              })
            }}
          >
            Terminer
          </span>
        </div>
      ),
    },
  ];

  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2">
        <div className="flex flex-row text-center justify-between">
          <div className="flex flex-col text-left">
            <h1 className="text-xl ">Les informations en cours</h1>
            
          </div>

          <React.Fragment>
            <Modal
              show={state.showModal}
              size={'sm'}
              onClose={() => initState()}>
              <Modal.Header>Terminer</Modal.Header>
              <Modal.Body className="space-y-6">
                <div>
                  <p className="text-gray-600 pb-5">Vous êtes sur le point de terminer cette information, voulez-vous continuer?</p>
                  <div className="flex justify-between gap-10">
                    <button
                      onClick={() => initState()}
                      className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-gray-800 bg-gray-400 focus:outline-none"
                    >Annuler</button>
                    <button
                      type="submit"
                      onClick={() => {
                        _terminer.mutate(state.gymspaId?._id)
                      }}
                      className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 focus:outline-none">
                      {
                        !_terminer.isLoading ? 'Terminer' : <LoadingUi />
                      }
                    </button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </React.Fragment>
        </div>
      </div>

      {
        _gymspa.isSuccess && _gymspa?.data?.data?.en_cours?.length !== 0
          ? <TableUi columns={COLUMNS} data={_gymspa?.data?.data?.en_cours} colsHidden={["_id"]} />
          : <p className="text-gray-600 text-sm">Aucune information trouvée</p>

      }

    </div>
  );
};
